let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6cal7")).then(() => parcelRequire('5y4bu'));